import React from 'react';
import style from './style.scss';

const MultiPicker = (PickerComponent) => {
  return (props) => {
    const { id, value = [], onChange, ...rest } = props;
    return (
      <div className={style.picker}>
        <div>Add a item - <PickerComponent
          id=""
          value=""
          onChange={v => value.includes(v) || onChange([...value, v])}
          {...rest}
        /></div>
        {value.map(subId => <div key={subId} className={style.row}>
          <PickerComponent
            key={subId}
            id={subId}
            value={subId}
            onChange={v => v === null
              ? onChange(value.filter(i => i !== subId))
              : value.includes(v) || onChange([...value.filter(i => i !== subId), v])
            }
            {...rest}
          />
        </div>)}
      </div>
    );
  };
};

export default MultiPicker;



// WEBPACK FOOTER //
// ./app/components/MultiPicker/index.js